import apiCall from "../axios";

const updateUser = async (payload: any) => {
  try {
    const res = await apiCall("PUT", `user`, payload);
    return res.data;
  } catch (e) {
    if (e) return e;
    return { error: "Unknown Error" };
  }
};

export default updateUser;
